<convfact-controlstock-form [controlstock]="controlstock" *ngIf="controlstock" (onSave)="saveData($event)">
</convfact-controlstock-form>

